import { render, staticRenderFns } from "./ColumnSaleStatusNfeio.vue?vue&type=template&id=3476206d"
import script from "./ColumnSaleStatusNfeio.vue?vue&type=script&lang=js"
export * from "./ColumnSaleStatusNfeio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports